import { InjectionToken } from '@angular/core';
import { AppConfig } from './config.service';

export const APP_CONFIG = new InjectionToken<AppConfig>('APP_CONFIG');
